import { Injectable, signal } from '@angular/core';

@Injectable()
export class LanguageStateService {
  isLoaded = signal(false);

  setLoaded() {
    this.isLoaded.set(true);
  }

  get getLanguageState() {
    return this.isLoaded();
  }
}
